/* eslint react/forbid-prop-types: 0 */
/* global globals, translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

const SubscriptionPaymentSummary = (props) => {
  const { data } = props;

  // Savings (with no campaign) / Discount (with campaign)
  const savings = () => {
    const value = data.campaign ? data.campaign.discount : data.savings;
    const text = data.campaign ? 'txt: atlaide' : 'txt: ietaupījums';
    const tcg = data.campaign ? ' tcg' : '';
    //
    return (
      <div>
        <div className={`paymentOption-bigText${tcg}`}>{value}</div>
        <div className={`paymentOption-smallText${tcg}`}>{get(translations, text, text)}</div>
      </div>
    );
  };

  // For now, this includes only coupon text,
  // but can adjust to include other additional info as well
  const additional = () => {
    const text = get(data, 'couponText', '');
    if (!text.length) {
      return null;
    }

    // Text with no ':'
    if (!text.includes(':')) {
      return (
        <div className="paymentOption-additional">
          <div className="paymentOption-bigText">{text}</div>
          <div className="paymentOption-line mbs" />
        </div>
      );
    }

    // Text with ':'. For example: 'With coupon code: XXXXXXX'.
    const parts = text.split(':');
    return (
      <div className="paymentOption-additional">
        <div className="paymentOption-smallText mbxs">{`${parts[0]}:`}</div>
        <div className="paymentOption-bigText">{parts[1]}</div>
        <div className="paymentOption-line mbs" />
      </div>
    );
  };

  // Amount to pay
  const amountToPay = () => {
    // With no campaign
    if (!data.campaign) {
      return (
        <span className="paymentOption-amount">
          <span className="paymentOption-bigText">{data.amountToPay.toFixed(2)}</span>
        </span>
      );
    }
    // With campaign
    return (
      <div className="dib">
        <span className="paymentOption-amount tdlt">
          <span className="paymentOption-bigText">{data.amountToPay.toFixed(2)}</span>
        </span>
        <span className="paymentOption-amount-special tcr">
          <span className="paymentOption-bigText">{` ${data.campaign.amountToPay.toFixed(2)}`}</span>
        </span>
      </div>
    );
  };

  //
  return (
    <div className="paymentOption-summary">
      <div className="paymentOption-bigText">{data.termText}</div>
      <div className="paymentOption-line" />
      <div className="paymentOption-periodPrice">
        <span className="paymentOption-bigText">{`${data.pricePerDay.toFixed(2)} `}</span>
        <span className="paymentOption-smallText">
          {`${get(globals, 'currency', '')}/${get(translations, 'txt: dienā', 'dienā')}`}
        </span>
      </div>
      <div className="paymentOption-line" />
      {savings()}
      <div className="paymentOption-line" />
      {additional()}
      {amountToPay()}
      <span className="paymentOption-smallText">{` ${get(globals, 'currency', '')}`}</span>
      <div className="paymentOption-smallText">{get(translations, 'txt: apmaksai', 'apmaksai')}</div>
    </div>
  );
};

SubscriptionPaymentSummary.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default SubscriptionPaymentSummary;
